<template>
  <div>
    <v-dialog scrollable max-width="1200px" v-model="model" persistent>
      <material-card :title="title" :color="$vuetify.theme.themes.light.success" icon="add" v-if="item">
        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row justify-center>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <trans-textbox
                    v-model="item"
                    :label="$t('globals.name')"
                    field="Name"
                    :rules="[$rules.required]"
                    class="required"
                  ></trans-textbox>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    :label="$t('globals.category')"
                    v-model="item.Category"
                    :rules="[$rules.required]"
                    class="required"
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <trans-enum
                    :value.sync="item.Coverage"
                    :items="options.Enums.Coverage"
                    :label="
                      $t(
                        'globals.coverage'
                      )
                    "
                    :rules="[$rules.required]"
                    class="required"
                  ></trans-enum>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    :label="$t('headers.employer_files.code')"
                    v-model="item.Code"
                    :rules="[
                      $rules.required,
                      $rules.numericString,
                      $rules.dynamic.upToLength(5),
                    ]"
                    class="required"
                  ></no-autocomplete-textfield>
                </div>
                <template v-if="item.Coverage === 'Dental'">
                  <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                    <v-checkbox
                      :label="$t('headers.benefits_index.final_procedure')"
                      v-model="item.FinalProcedure"
                    ></v-checkbox>
                  </div>
                  <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                    <v-autocomplete
                      v-model="item.TreatmentSite"
                      :items="options.Models.TreatmentSite"
                      :label="$t('headers.benefits_index.treatment_site')"
                      item-value="Id"
                      item-text="Name"
                    />
                  </div>
                  <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                    <v-checkbox
                      :label="$t('headers.benefits_index.surfaces_required')"
                      v-model="item.SurfacesRequired"
                    ></v-checkbox>
                  </div>
                  <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3" v-if="item.SurfacesRequired">
                    <v-autocomplete
                      v-model="item.NoOfSurfacesAllowed"
                      :items="noOfSurfacesAllowedItems"
                      :label="
                        $t('headers.benefits_index.no_of_surfaces_allowed')
                      "
                      :rules="[$rules.required]"
                      class="required"
                    ></v-autocomplete>
                  </div>
                  <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                    <v-autocomplete
                      v-model="item.UnitValue"
                      :items="unitValueItems"
                      :label="$t('headers.benefits_index.unit_value')"
                    ></v-autocomplete>
                  </div>
                </template>
                <template v-if="item.Coverage === 'Health'">
                  <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                    <v-checkbox
                      :label="$t('headers.benefits_index.is_prescription_drugs')"
                      v-model="item.IsPrescriptionDrugs"
                    ></v-checkbox>
                  </div>
                </template>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3">
                    <v-checkbox
                      :label="$t('headers.benefits_index.requires_din')"
                      v-model="item.RequiresDin"
                    ></v-checkbox>
                  </div>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')" :loading="saving">
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="save"
            :disabled="!valid"
            :loading="saving"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import ErrorHandler from "../../components/ErrorHandler.vue";
import { translate2 } from "../../trans2";
import { mapActions, mapGetters } from "vuex";
import TransTextbox from "../TransTextbox.vue";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";
import TransEnum from "../TransEnum.vue";
import TransSelect from "../TransSelect.vue";
export default {
  props: ["model", "item"],
  components: {
    ErrorHandler,
    TransTextbox,
    NoAutocompleteTextfield,
    TransEnum,
    TransSelect,
  },
  data() {
    return {
      error: null,
      successDialog: false,
      valid: false,
      saving: false,
      file: null,
      noOfSurfacesAllowedItems: [],
      unitValueItems: [],
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["language"]),
    title() {
      if (this.item && this.item.Id) {
        return this.$t(
          "components.benefits.benefit_form_dialog.edit_benefit_{}",
          [translate2(this.item, "Name")]
        );
      }
      return this.$t("components.benefits.benefit_form_dialog.add_benefit");
    },
  },
  watch:{
    "item.SurfacesRequired": {
      handler(v) {
        if (!v) {
          this.item.NoOfSurfacesAllowed = null;
        }
      }
    }
  },
  mounted() {
    this.noOfSurfacesAllowedItems = this.createItems(1, 5, 1);
    this.unitValueItems = this.createItems(0.5, 10, 0.5);
    console.log(this.noOfSurfacesAllowedItems, this.unitValueItems);
  },
  methods: {
    ...mapActions("claims", ["addBenefits", "updateBenefit"]),
    save() {
      let item = JSON.parse(JSON.stringify(this.item));
      item.Name = item.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Name;
      if (item.TreatmentSite !== null && item.TreatmentSite !== undefined) {
        item.TreatmentSiteId = item.TreatmentSite.Id;
        delete item.TreatmentSite;
      }
      // if (item.UnitValue) {
      //   const unitValue = parseFloat(item.UnitValue);
      //   if (isNaN(item.UnitValue)) {
      //     item.UnitValue = 0.0;
      //   } else {
      //     item.UnitValue = unitValue
      //   }
      // }
      if (item.Id) {
        return this.update(item);
      }
      return this.add(item);
    },
    async add(item) {
      try {
        this.saving = true;
        await this.addBenefits({
          payload: [item],
        });
        this.$emit("success", this.$t("globals.success"));
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async update(item) {
      try {
        this.saving = true;
        await this.updateBenefit({
          id: item.Id,
          payload: item,
        });
        this.$emit("success", this.$t("globals.success"));
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    createItems(min, max, step) {
      const items = [];
      for (let i = min; i <= max; i += step) {
        items.push(i);
      }
      return items;
    },
  },
};
</script>

<style></style>
